namespace $.$$ {

	const { rem } = $mol_style_unit

	$mol_style_define( $eve_app_page_components_alert, {

		Variants: {
			display: 'flex',
			flexDirection: 'column',
			gap: rem( 1 ),
		},

		With_description: {
			display: 'flex',
			flexDirection: 'column',
			gap: rem( 1 ),
		},

		Closable: {
			display: 'flex',
			flexDirection: 'column',
			gap: rem( 1 ),
		},

		Without_icon: {
			display: 'flex',
			flexDirection: 'column',
			gap: rem( 1 ),
		},

	} )

}

